import { useQuery } from '@tanstack/react-query';
import SupportWidgetKeys from '../queryKeys';
import { getConversationsAPI } from '../../../api/supportChat';
import { notifyError } from '../../../utils/notify';
import transformFiltersForApi from '../utils/transformFiltersForApi';

const { getConversations } = SupportWidgetKeys;

const fetchConversations = async conversationFilters => {
  const apiFilters = transformFiltersForApi(conversationFilters);
  const { data } = await getConversationsAPI(apiFilters);
  return data;
};

const useGetConversationsQuery = conversationFilters =>
  useQuery(
    [
      getConversations,
      conversationFilters.searchTerm,
      conversationFilters.markedAsNotHelpful,
      conversationFilters.page,
      conversationFilters.limit,
      conversationFilters.tags,
      conversationFilters.csatScore,
      conversationFilters.includeProductionHubs,
      conversationFilters.includeSuperadmin,
      conversationFilters.includeClientAdmin,
      conversationFilters.includeNonAdminUsers,
      conversationFilters.raisedTicket,
      conversationFilters.flaggedInternally,
      conversationFilters.dateRange?.start,
      conversationFilters.dateRange?.end,
    ],
    () => fetchConversations(conversationFilters),
    {
      retry: false,
      onError: e => {
        notifyError(e, false, 'Error fetching conversations');
      },
    }
  );

export default useGetConversationsQuery;
